import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Plus } from 'lucide-react';
import { blogs } from '../mock';

export default function BlogSection() {
  const [start, setStart] = useState(0);
  const visible = 3;
  const max = Math.max(0, blogs.length - visible);

  return (
    <section className="w-full bg-white py-20 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            <div className="text-[11px] tracking-[0.4em] uppercase text-[#7a1a2a] mb-3">Latest Blog</div>
            <h2 className="serif text-4xl md:text-5xl font-light text-[#1a1a1a]">Check Out Our Newest Posts</h2>
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="link-underline text-[#7a1a2a]">View All <span aria-hidden>&rarr;</span></a>
            <div className="hidden md:flex gap-2">
              <button onClick={() => setStart(Math.max(0, start - 1))} disabled={start === 0} className="w-10 h-10 rounded-full border border-[#7a1a2a] text-[#7a1a2a] hover:bg-[#7a1a2a] hover:text-white disabled:opacity-30 transition-colors flex items-center justify-center"><ChevronLeft className="w-4 h-4" /></button>
              <button onClick={() => setStart(Math.min(max, start + 1))} disabled={start === max} className="w-10 h-10 rounded-full border border-[#7a1a2a] text-[#7a1a2a] hover:bg-[#7a1a2a] hover:text-white disabled:opacity-30 transition-colors flex items-center justify-center"><ChevronRight className="w-4 h-4" /></button>
            </div>
          </div>
        </div>

        <div className="overflow-hidden">
          <div className="flex transition-transform duration-700 ease-out" style={{ transform: `translateX(-${start * (100 / visible)}%)` }}>
            {blogs.map((b, i) => (
              <article key={i} className="shrink-0 w-full md:w-1/3 px-2 md:px-3 group">
                <a href="#" className="block">
                  <div className="img-zoom h-72 md:h-80 bg-neutral-200 overflow-hidden">
                    <img src={b.image} alt={b.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="pt-5">
                    <h3 className="serif text-xl md:text-2xl font-light text-[#1a1a1a] leading-snug mb-4 group-hover:text-[#7a1a2a] transition-colors">{b.title}</h3>
                    <div className="flex items-center justify-between">
                      <span className="text-[11px] tracking-[0.25em] uppercase text-[#7a1a2a]">Read More</span>
                      <span className="w-8 h-8 rounded-full border border-[#7a1a2a] text-[#7a1a2a] flex items-center justify-center group-hover:bg-[#7a1a2a] group-hover:text-white transition-colors"><Plus className="w-4 h-4" /></span>
                    </div>
                  </div>
                </a>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
